import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Component({
  selector: 'anihis-fiv-test',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  templateUrl: './fiv-test.component.html',
  styleUrls: ['./fiv-test.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FivTestComponent implements OnInit, OnDestroy {
  @Output() formChange = new EventEmitter<any>();

  form: FormGroup = new FormGroup({
    fivTestResult: new FormGroup({
      en: new FormControl(''),
      sr: new FormControl(''),
    }),
    felvTestResult: new FormGroup({
      en: new FormControl(''),
      sr: new FormControl(''),
    }),
  });

  private subs: Subscription[] = [];
  private translocoService = inject(TranslocoService);
  currentLang: 'en' | 'sr' = 'en';

  ngOnInit(): void {
    const lang =
      (this.translocoService.getActiveLang &&
        this.translocoService.getActiveLang()) ||
      '';
    this.currentLang =
      typeof lang === 'string' && lang.startsWith('sr') ? 'sr' : 'en';

    // emit initial value
    this.formChange.emit(this.form.value);

    // subscribe primary fields (fivTestResult and felvTestResult)
    ['fivTestResult', 'felvTestResult'].forEach((groupName) => {
      const vis = this.form.get([groupName, this.currentLang]);
      const oth = this.form.get([
        groupName,
        this.currentLang === 'en' ? 'sr' : 'en',
      ]);
      if (vis) {
        const s = (vis as any).valueChanges.subscribe((v: any) => {
          if (oth) oth.setValue(v, { emitEvent: false });
          this.formChange.emit(this.form.value);
        });
        this.subs.push(s);
      }
    });

    if ((this.translocoService as any).langChanges$) {
      const langSub = (this.translocoService as any).langChanges$.subscribe(
        () => {
          const newLang =
            (this.translocoService.getActiveLang &&
              this.translocoService.getActiveLang()) ||
            '';
          this.currentLang =
            typeof newLang === 'string' && newLang.startsWith('sr')
              ? 'sr'
              : 'en';
          this.unsubscribeAll();
          ['fivTestResult', 'felvTestResult'].forEach((groupName) => {
            const vis2 = this.form.get([groupName, this.currentLang]);
            const oth2 = this.form.get([
              groupName,
              this.currentLang === 'en' ? 'sr' : 'en',
            ]);
            if (vis2) {
              const s2 = (vis2 as any).valueChanges.subscribe((v: any) => {
                if (oth2) oth2.setValue(v, { emitEvent: false });
                this.formChange.emit(this.form.value);
              });
              this.subs.push(s2);
            }
          });
        },
      );
      this.subs.push(langSub);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  private unsubscribeAll() {
    this.subs.forEach((s) => s.unsubscribe());
    this.subs = [];
  }
}
